module.exports = __webpack_public_path__ + "static/media/sejo2.546e0576.png";